import { useMemo } from 'react';
import { useExperimentContext } from '@americanexpress/one-experiments';
import { HOMEPAGE_REDESIGN_EXPERIMENT } from '../constants/experimentConstant';

export const useIsHomePageVariantHook = () => {
  const { selectors: { getExperimentVariant } } = useExperimentContext();
  const experimentData = getExperimentVariant(HOMEPAGE_REDESIGN_EXPERIMENT);

  return useMemo(() => experimentData
  && experimentData.dimension === 'search_widget'
  && experimentData.variant !== 'control', [experimentData?.dimension, experimentData?.variant]);
};
